import KunLoading45 from './src/index'

KunLoading45.install = function (Vue) {
	Vue.component(KunLoading45.name, KunLoading45);
}

export default KunLoading45;
